import gql from 'graphql-tag'

export const ADD_INPI_PROCESS = gql`
  mutation addInpiProcess($processNumber: String!, $processType: String) {
    addInpiProcess(processNumber: $processNumber, processType: $processType) {
      _id
      processNumber
      processType
      status
      trademarkName
    }
  }
`

export const REMOVE_INPI_PROCESS = gql`
  mutation removeInpiProcess($id: String!) {
    removeInpiProcess(id: $id) {
      success
    }
  }
`

export const SAVE_INPI_NOTIFICATION_RECIPIENTS = gql`
  mutation saveInpiNotificationRecipients($accountUserIds: [String]!) {
    saveInpiNotificationRecipients(accountUserIds: $accountUserIds) {
      accountUserIds
    }
  }
`
